import { render } from "./CommentNotifications.vue?vue&type=template&id=d99bf38a&scoped=true"
import script from "./CommentNotifications.vue?vue&type=script&lang=js"
export * from "./CommentNotifications.vue?vue&type=script&lang=js"

import "./CommentNotifications.vue?vue&type=style&index=0&id=d99bf38a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d99bf38a"]])

export default __exports__